import React from 'react';
import { m } from 'framer-motion';
import { QuoteIcon } from 'lucide-react';
import { SectionTag } from '../ui/SectionTag';
export function AboutAuthor() {
  return <section className="bg-white py-14 sm:py-16" data-id="element-22" data-mp="2hf4lkrab19s1">
      <div className="mx-auto max-w-2xl px-6 text-center sm:px-8" data-id="element-23" data-mp="2m9h3gww4ud1o">
        <SectionTag data-id="element-24" data-mp="2qaarrrdhltv3">Acerca de Balonmano Pro 360</SectionTag>

        <m.div initial={{
        opacity: 0,
        y: 14
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="mt-5 rounded-2xl border-l-4 border-azul bg-azul-light p-6 text-left" data-id="element-25" data-mp="2qbvlxfvw3asf">
          <QuoteIcon size={22} className="text-azul" aria-hidden="true" data-id="element-26" data-mp="22in8nvmgvn3d" />
          <p className="mt-3 text-lg font-semibold leading-relaxed text-azul" data-id="element-27" data-mp="27jjjkt58k9ia">
            "He volcado en este sistema los esquemas reales que utilizamos para transformar entrenamientos
            improvisados en sesiones con criterio profesional. Menos búsqueda en YouTube y más balonmano
            real en la pista."
          </p>
          <p className="mt-4 text-base leading-relaxed text-gris-texto" data-id="element-28" data-mp="2aqjvpgkncltt">
            Entrenadores del balonmano base español con más de una década de experiencia en cantera.
            Formados en la pista pequeña, en el vestuario ruidoso y en la reunión de padres difícil. Todo
            lo que encontrarás en Balonmano Pro 360 viene de ahí. No de la teoría. De la pista real.
          </p>
        </m.div>
      </div>
    </section>;
}